import React from "react";
import { Link } from "react-router-dom";
import { BottomBannerArrow } from "../../../../styles/img/svg/BottomBannerArrow";
import { UiCol, UiRowContainer } from "../grid-container/GridContainer";

export const UiBannerBottomBar = (props) => {
    return(
        <>
        <div className="sb-baner-bottom-bar-wrapper">
            <UiRowContainer>
                <UiCol lg="12">
                    <BottomBannerArrow />
                    <p>
                    <Link to={props.prevPageLink} >{props.prevPage}</Link> &lt; <Link to={props.currentPageLink}> {props.currentPage}</Link>
                    </p>
                </UiCol>
            </UiRowContainer>
        </div>
        </>
    )
}